<!-- 宣告表 详情 sqm -->
<template>
  <ComponentDeclarationForm :kindType="data.kindType" :getData="data.getData" v-if="data.getData.supplyCode" @submitBtn="submit" @backBtn="routerBack"
    :subLoading="data.subLoading"></ComponentDeclarationForm>
  <div v-else style="width:100%; height: 600px;" v-loading="data.pageLoading"></div>
</template>



<script setup>
//Automatic script writing.
import h_i18n from '@/utils/Internationalization';

  import { reactive, getCurrentInstance, onMounted, onUpdated, nextTick, onBeforeMount, onActivated, onDeactivated } from "vue";
  import { useRoute } from "vue-router";
  import axios from "axios";
  import ComponentDeclarationForm from "../ComponentDeclarationForm"
  const { proxy, ctx } = getCurrentInstance()
  const route = useRoute()

  const data = reactive({
    kindType:'sqmDetail',
    getData:{},
    subLoading:false,
    pageLoading:false,
  })
  const backOrClose = () => {
    if(route.query.backUrl && route.query.backUrl=== 'closePage'){
      window.close()
      // 兜底：close 失败时跳回首页或指定页
      setTimeout(() => {
        // window.close() 仍会执行到这里，说明没关成功
        proxy.$router.replace('/')
      }, 200)
    }else{
      proxy.$router.back();
    }
  }
  const routerBack = () => {
    backOrClose()
    // proxy.$router.back()
  }
  const getInfo = () => {
    data.pageLoading = true
    proxy.$http({
      url:'/base/newrohs/getMainInfo?id='+data.id,
      method:'get',
    }).then((res=>{
      data.getData.dataOfTable = res.data.data.detailList
      data.getData.basalInfo = res.data.data.roHSMainDTO
    })).catch(err=>{

    }).finally(()=>{
      // 是否同意也写到了 basalInfo里 
      
      // 审核数据 列表化
      let tem = data.getData.basalInfo
      data.getData.auditData = [
        {role:h_i18n('5200ed8b578c7b02a035f9b7424830d5'),name:tem.savePerson,time:tem.saveTime,result:'',opinion:''},
        {role:h_i18n('43e33e242b484dc4633ff7d6519c307d'),name:tem.auditTwoName,time:tem.auditTwoDate,result:tem.auditTwoStatus,opinion:tem.auditTwoMark},
        // {role:'互联工厂',name:tem.checkPerson,time:tem.checkTime,result:tem.checkStatus,opinion:tem.checkMark},
        {role:h_i18n('7d0d9d5a6a61aa1f3037e2514fe3a18d'),name:tem.checkPerson?"-":"",time:tem.checkTime,result:tem.checkStatus,opinion:tem.checkMark},
      ]
      data.getData.supplyCode = route.query.supplyCode ?  route.query.supplyCode : ''
      data.getData.supplyName = route.query.supplyName ?  route.query.supplyName : ''      
      data.pageLoading = false
    })
  }

  onBeforeMount(()=>{
    if (route.query) {
      // data.supplyCode = route.query.supplyCode ?  route.query.supplyCode : ''
      // data.supplyName = route.query.supplyName ?  route.query.supplyName : ''
      data.kindType = route.query.kindType ? route.query.kindType : 'sqmDetail'
      data.conformityDeclarationsId = route.query.conformityDeclarationsId ?  route.query.conformityDeclarationsId : undefined
      data.sourceId = route.query.sourceId ?  route.query.sourceId : undefined
      data.userName = route.query.userName ?  route.query.userName : ''
      data.trueName = route.query.trueName ?  route.query.trueName : ''
      data.getData.userName = route.query.userName ?  route.query.userName : ''
      data.getData.trueName = route.query.trueName ?  route.query.trueName : ''
      data.id = route.query.id ?  route.query.id : ''
    }    
  })

  onMounted(() => {
    if(route.query.dataFrom != 'sqm'){
      proxy.$router.replace('/404')
      return
    }
    if(!route.query.supplyCode){
      proxy.info({title: h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'), message: h_i18n('c0f92e28b64a4268408f10aa60dc47c8'),confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
        callback: (action) => {
          routerBack()
        },})
      return
    }
    getInfo()
    for(let i = 1 ; i < 10; i++){
      setTimeout(() => {
        proxy.postThisPageHeightMore()
      }, i*100);
    }
  })
</script>

<style>

</style>